// src/components/game/RememberOverlay.jsx
// Displays the memorisation screen before the Memory Grid game starts.
//
// IMPORTANT: This component receives `targetGrid` as a prop from LevelRunner.
// It NEVER generates its own grid. This ensures the preview and the game
// always show the exact same pattern.

import React from 'react';
import { getColorStyle } from '../../utils/randomGrid';

/**
 * @param {object}  props
 * @param {Array}   props.targetGrid      — the canonical target grid (9 elements, nulls for empty cells)
 * @param {number}  props.previewSeconds  — how long the overlay stays visible
 * @param {boolean} props.hiding          — true when the fade-out animation is active
 */
const RememberOverlay = ({ targetGrid, previewSeconds, hiding }) => {
  return (
    <div className={`lvl1-remember-overlay ${hiding ? 'hiding' : ''}`}>
      <div className="lvl1-remember-box">
        <div className="lvl1-remember-title">Remember the order!</div>

        <div className="lvl1-remember-grid">
          {targetGrid.map((colorId, i) => {
            const c = colorId ? getColorStyle(colorId) : null;
            return (
              <div
                key={i}
                className={`lvl1-remember-cell ${!colorId ? 'empty' : ''}`}
                style={
                  c
                    ? { background: c.bg, boxShadow: `0 0 22px ${c.glow}66` }
                    : {}
                }
              />
            );
          })}
        </div>

        <div className="lvl1-timer-bar-wrap">
          <div
            className="lvl1-timer-bar"
            style={{ animationDuration: `${previewSeconds}s` }}
          />
        </div>
      </div>
    </div>
  );
};

export default RememberOverlay;